import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/stock-out-from-emr";

export const saveOrUpdate = (searchObject) => axios.post(API_PATH + "/save", searchObject);

export const getStockOutById = (id) => axios.get(API_PATH + "/getById/" + id);

export const pagingStockOutFromEMR = (obj) => axios.post(API_PATH + "/search-by-page", obj)

export const deleteStockOutFromEMR = (id) => axios.delete(API_PATH + "/mark-delete/" + id)
//phat het thuoc
export const getDispenseAllMedication = (obj) => axios.post(API_PATH + "/dispense-all-medication", obj)
//sd het thuoc
export const administeringMedicationPatient = (obj) => axios.post(API_PATH + "/administering-medication-patient", obj)
